module.exports = __webpack_public_path__ + "UX50.png?54c616e96db6645ba2b2784476e68147";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX50.png
// module id = 102
// module chunks = 0